module.exports = __webpack_public_path__ + "static/media/raaz_img1.c4bea2b1.png";